import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';

export const ModalTitleStyles = {
  Header: styled.h2`
    display: block;
    margin-bottom: ${tokens.spacer.x3};

    ${tokens.text('header2')};
  `,
  Emphasis: styled.span`
    color: ${tokens.color.text_warning};
  `,
};
